import React from "react";
import { render } from "react-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";

const data1 = [
  [0, 20],
  [1, 10],
  [2, 10],
  [3, 10],
  [4, 20]
];
const data2 = [
  [0, 5],
  [1, 10],
  [2, 5],
  [3, 8],
  [4, 15]
];
const data3 = [
  [0, 0],
  [1, 0.3],
  [2, 0.5],
  [3, 0.2],
  [4, 1]
];

const getSeries = (stat, chart) => {
  const clicks = [];
  const shows = [];
  const ctr = [];

  let clickKey = "clicks";
  let showKey = "shows";
  let ctrKey = "ctr";

  if (chart == "inf") {
    clickKey = "inf_" + clickKey;
    showKey = "inf_" + showKey;
    ctrKey = "inf_" + ctrKey;
  } else if (chart == "top") {
    clickKey = "top_" + clickKey;
    showKey = "top_" + showKey;
    ctrKey = "top_" + ctrKey;
  }

  stat.forEach(s => {
    const mDate = moment(s.date);
    const date = Date.UTC(mDate.year(), mDate.month(), mDate.date());

    clicks.push([date, s[clickKey]]);
    shows.push([date, s[showKey]]);
    ctr.push([date, s[ctrKey] || 0]);
  });

  return [clicks, shows, ctr];
};

const makeOptions = (stat, chart, dateFormatFunc) => {
  const [clicks, shows, ctr] = getSeries(stat, chart);

  const options = {
    plotOptions: {
      spline: {
        marker: {
          enabled: false
          /*states: {
                        hover: {
                            enabled: false
                        }
                    }*/
        }
      },
      areaspline: {
        marker: {
          enabled: false
          /*states: {
                        hover: {
                            enabled: false
                        }
                    }*/
        }
      }
    },
    chart: {
      height: 338,
      //width: 1170,
      margin: [0, 0, 20, 0],
      spacing: [0, 0, 0, 0],
      padding: [0, 0, 0, 0]
    },

    xAxis: {
      type: "datetime",
      gridLineWidth: 1,
      dateTimeLabelFormats: {
        day: "%e. %b",
        week: "%e. %b",
        month: "%b '%y",
        year: "%Y"
      },
      labels: {
        formatter: function () {
          return dateFormatFunc(this.value);
        }
      }
    },

    yAxis: [
      {
        gridLineWidth: 1
      },
      {
        gridLineWidth: 1
      },
      {
        gridLineWidth: 1
      }
    ],

    credits: {
      enabled: false
    },

    title: false,
    subtitle: false,
    exporting: {
      enable: false
    },
    labels: {
      enabled: false
    },
    series: [
      {
        type: "areaspline",
        data: clicks,
        name: "Клики",
        showInLegend: false,
        color: "#FFDFD8",
        fillOpacity: 1,
        yAxis: 2
      },
      {
        type: "areaspline",
        data: shows,
        name: "Показы",
        showInLegend: false,
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
          stops: [
            [0, "#FF2320"],
            [0.4, "#FF6720"],
            [0.8, "#FFBD69"],
            [1, "#ED9F3A"]
          ]
        },
        color: "#FF8B4F"
      },
      {
        type: "spline",
        data: ctr,
        name: "CTR",
        showInLegend: false,
        color: "#FE4D4B",
        yAxis: 1
      }
    ]
  };
  return options;
};

const TeaserStatChart = ({ stat, chart, dateFormatFunc }) => {
  const options = makeOptions(stat, chart, dateFormatFunc);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default TeaserStatChart;
